module.exports = __webpack_public_path__ + "static/media/plate2Img5.2f09fb4b.png";